import { EventEmitter } from '@angular/core';

export interface ThenableEvent<T> {
	value: T;
	next: any;
}

export class ThenableEventEmitter<T> extends EventEmitter {
	constructor(isAsync?: boolean) {
		super(isAsync);
	}

	override emit(value?: T) {
		let next: (value: unknown) => void = () => { };
		const promise = new Promise((resolve) => {
			next = resolve;
		});

		let thenableEvent: ThenableEvent<T> = { value, next };
		super.emit(thenableEvent);

		return promise;
	}
}